import React, { useState } from "react";
import { SideMenu, SideMenuItem, SideMenuTop } from "../../../components/components/molecules/SideMenu";
import { useLocation } from "react-router-dom";
import PAGES from "../../../../../constants/pages";
import SendFeedbackPanel from "../../components/molecules/SendFeedbackPanel/SendFeedbackPanel";
import { IconName } from "@telia/teddy";

interface NavigationItem {
    label: string;
    path: string;
    icon?: IconName;
}

const navigationItems: NavigationItem[] = [
    {
        label: "Butikk",
        path: PAGES.RETAILER.ADMIN.SHOP.URL,
        icon: "store",
    },
    {
        label: "Selgere",
        path: PAGES.RETAILER.ADMIN.SELLERS.URL,
        icon: "care",
    },
];

const AdminSidebar: React.FC = () => {
    const location = useLocation();
    const [isReportErrorOpen, setIsReportErrorOpen] = useState(false);

    return (
        <div className="sidebar">
            <SideMenu className="sidebar__menu">
                <SideMenuTop>
                    {navigationItems.map((item) => (
                        <SideMenuItem
                            label={item.label}
                            color="grey"
                            icon={item.icon}
                            key={item.path}
                            onClick={() => window.location.assign(item.path)}
                            active={location.pathname === item.path}
                        />
                    ))}
                    <SideMenuItem
                        className="sidebar__menu-item--bottom"
                        label="Ny ordre"
                        color="grey"
                        icon="plus"
                        onClick={() => window.location.assign(PAGES.RETAILER.NEWORDER.URL)}
                    />
                    <SideMenuItem
                        label="Gi tilbakemelding"
                        color="grey"
                        icon="send"
                        onClick={() => setIsReportErrorOpen(true)}
                    />
                </SideMenuTop>
            </SideMenu>
            <SendFeedbackPanel open={isReportErrorOpen} onOpenChange={setIsReportErrorOpen} />
        </div>
    );
};

export default AdminSidebar;
